const relatieDeelnameListing = {
	init() {
		// Verwijderd atable event attibute
		const filterYearElement = document.getElementById('filter_year');
		if (filterYearElement) {
			filterYearElement.removeAttribute('data-atable-header-toolbar-select');
		}
		// Verkrijg huidige jaartal uit url en set select values
		const year = window.location.pathname.split('/').pop();
		if (typeof year !== 'undefined' && filterYearElement) {
			filterYearElement.value = year;
		}

		// Forward naar geselecteerde jaartal
		if (filterYearElement) {
			filterYearElement.addEventListener('change', function () {
				window.location.href = this.value;
			});
		}
	},
};

export default relatieDeelnameListing;
